import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import { HTTPError } from "common/helpers/HTTP";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

interface AssignSeatModalProps {
  isOpen: boolean;
  account: WorkspaceAccount;
  onClose: () => void;
}

export default function AssignSeatModal({
  isOpen,
  account,
  onClose,
}: AssignSeatModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { assignLicense, isAssigningLicense } = useLicenseMutations();

  function assignLicenseToOwner() {
    assignLicense({ accountId: account.id })
      .then(onClose)
      .catch((error) => {
        toast.error(
          error instanceof HTTPError && error.serverMessage
            ? error.serverMessage
            : "Failed to assign seat",
        );
      });
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Content>
        <Header
          title={<>Assign seat to {account.full_name}?</>}
          subtitle="You will get full access to LinkedIn Outreach and campaigns"
        />

        <Footer className="justify-end">
          <Button
            variant="gradient"
            onClick={assignLicenseToOwner}
            isLoading={isAssigningLicense}
          >
            Assign
          </Button>
          <Button
            variant="secondary-black"
            disabled={isAssigningLicense}
            onClick={onClose}
          >
            Cancel
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
